import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import useStore from '@/utils/store/common';
import { useRouter } from 'vue-router/composables';
import { V2Device } from 'ctp-search-device';
import TrackingRecords from '@/components/common/TrackingRecords/TrackingRecords.vue';
import DeviceBloc from './components/DeviceBloc/DeviceBloc.vue';
import VehicleBloc from './components/VehicleBloc/VehicleBloc.vue';
import LastPosition from './components/LastPosition/LastPosition.vue';
import HistoryBloc from './components/HistoryBloc/HistoryBloc.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceDetails',
  props: {
  device: {
    type: Object,
    default: () => ({} as V2Device)
  },
  mapDataLoaded: {
    type: Boolean,
    default: false
  },
  position: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;



const store = useStore();
const router = useRouter();

const getCurrentUserIsAbleTo = computed(() => store.getters['permissions/getCurrentUserIsAbleTo']);

const overlay = ref(false);

const vehiclePerso = computed(() => {
  if (props.device.devicePersonalisationState && props.device.devicePersonalisationState.inProgress) {
    return props.device.devicePersonalisationState.targetPersonalisation?.vehicleInfo;
  }
  return props.device.devicePersonalisationState?.currentPersonalisation?.vehicleInfo;
});

function goToPerso() {
  let id = props.device.shortDeviceId;
  if (props.device.type === 'vdolink') {
    id = props.device.pairingInfo?.dtcoId;
  }
  router.push({
    name: 'personalisation',
    params: {
      deviceId: id || ''
    }
  });
}

return { __sfc: true,props, store, router, getCurrentUserIsAbleTo, overlay, vehiclePerso, goToPerso, TrackingRecords, DeviceBloc, VehicleBloc, LastPosition, HistoryBloc }
}

})